import Vue from 'vue'
import router from './router'
import BootstrapVue from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import App from './App.vue'

Vue.use(BootstrapVue)
Vue.config.productionTip = false
//Vue.loadScript("https://cdnjs.cloudflare.com/ajax/libs/cytoscape/3.20.0/cytoscape.min.js")

Vue.prototype.$show = false


// === GA START ===
function loadGA(measurementId) {
  // 1) load the gtag script
  const s = document.createElement('script')
  s.async = true
  s.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`
  document.head.appendChild(s)

  // 2) init dataLayer + gtag
  window.dataLayer = window.dataLayer || []
  function gtag(){ window.dataLayer.push(arguments) }
  window.gtag = gtag
  gtag('js', new Date())
  gtag('config', measurementId)
}

// call once on app boot
const GA_ID = 'G-PRKBYWWERB' // <-- your Measurement ID
loadGA(GA_ID)

// track SPA navigations as pageviews
router.afterEach((to) => {
  if (window.gtag) {
    window.gtag('config', GA_ID, { page_path: to.fullPath })
  }
})
// === GA END ===


new Vue({
  data: {
  },
  created() {
    document.title = 'Mutation';
  },
  // watch: {
  //   $route(to, from) {
  //     document.title = to.meta.title || 'Some Default';
  //   }
  // },
  methods: {
  },
  router,
  render: h => h(App),
}).$mount('#app')
